"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDropdown = _interopRequireDefault(require("../cwdropdown/CwDropdown"));

var _CwButton = _interopRequireDefault(require("../cwbutton/CwButton"));

var _CwDropdownService = require("../../utils/CwDropdownService");

var _CwThemeService = require("../../utils/CwThemeService");

var CwMenuButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwMenuButton, _React$Component);

  function CwMenuButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwMenuButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwMenuButton).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setIgnoreBlur", function (ignore) {
      _this._ignoreBlur = ignore;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleScroll", function (event) {
      // Hide dropdown when window is scrolled
      if (event.target === document || !event.target.className.includes('CwDropdown-dropDown')) {
        _this.setState({
          expanded: false,
          prevExpanded: true
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (event) {
      if (_this.keyDownHandlers[event.key]) _this.keyDownHandlers[event.key].call((0, _assertThisInitialized2.default)(_this), event);else {
        return;
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInputBlur", function () {
      if (_this._ignoreBlur) {
        return;
      } // IE fires a blur event when clicking the scrollbar - this prevents the dropdown from closing


      if (_this.cwDropdown && _this.cwDropdown.isMousedOver()) {
        _this.cwButton.focus();

        return;
      }

      _this.setState({
        expanded: false,
        highlightedIndex: null
      });

      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "highlightItemFromMouse", function (index) {
      _this.setState({
        highlightedIndex: index
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleInputClick", function () {
      if (_this.props.disabled) {
        return;
      }

      _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });

      _this._ignoreBlur = false;
    });
    _this.state = {
      value: '',
      expanded: false,
      highlightedIndex: null
    };
    _this.keyDownHandlers = {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        var itemsLength = this.getFilteredItems().length;
        if (!itemsLength) return;
        var highlightedIndex = this.state.highlightedIndex;
        var index = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? 0 : highlightedIndex + 1;
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index,
          expanded: true
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        var itemsLength = this.getFilteredItems().length;
        if (!itemsLength) return;
        var highlightedIndex = this.state.highlightedIndex;
        var index = highlightedIndex === 0 || highlightedIndex === null ? itemsLength - 1 : highlightedIndex - 1;
        this._performAutoCompleteOnKeyUp = true;
        this.setState({
          highlightedIndex: index,
          expanded: true
        });
      },
      Enter: function Enter(event) {
        if (this.state.expanded === false) {
          event.preventDefault();
          var itemsLength = this.getFilteredItems().length;
          if (!itemsLength) return;
          var highlightedIndex = this.state.highlightedIndex;
          var index = highlightedIndex === null || highlightedIndex === itemsLength - 1 ? 0 : highlightedIndex + 1;
          this._performAutoCompleteOnKeyUp = true;
          this.setState({
            highlightedIndex: index,
            expanded: true
          }); // menu is closed so there is no selection to accept -> do nothing
        } else if (this.state.highlightedIndex == null) {
          // input has focus but no menu item is selected + enter is hit -> close the menu, highlight whatever's in input
          this.setState({
            expanded: false
          });
        } else {
          // text entered + menu item has been highlighted + enter is hit -> update value to that of selected menu item, close the menu
          event.preventDefault();
          var item = this.getFilteredItems()[this.state.highlightedIndex];
          this.onMenuItemSelected(item);
        }
      },
      Escape: function Escape() {
        this.setState({
          highlightedIndex: null,
          expanded: false
        });
      }
    };
    return _this;
  }

  (0, _createClass2.default)(CwMenuButton, [{
    key: "onMenuItemSelected",
    value: function onMenuItemSelected(item) {
      var _this2 = this;

      this.setState({
        value: item.name,
        expanded: false,
        highlightedIndex: null
      }, function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(item);
        }

        if (_this2.props.onDropDownItemClick) {
          _this2.props.onDropDownItemClick(item);
        }
      });
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      this._ignoreBlur = false;
      this._performAutoCompleteOnUpdate = false;
      this._performAutoCompleteOnKeyUp = false;
      window.addEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll, true);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this._performAutoCompleteOnUpdate = true; // If `items` has changed we want to reset `highlightedIndex`
      // since it probably no longer refers to a relevant item

      if (this.props.items !== nextProps.items || // The entries in `items` may have been changed even though the
      // object reference remains the same, double check by seeing
      // if `highlightedIndex` points to an existing item
      this.state.highlightedIndex >= nextProps.items.length) {
        this.setState({
          highlightedIndex: null
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.expanded === true && prevState.expanded === false) {
        var menuPositions = (0, _CwDropdownService.setMenuPositions)(this.cwButton.cwButton);
        var menuLeft = menuPositions.menuLeft + menuPositions.menuWidth + 80 > window.innerWidth ? menuPositions.menuLeft - menuPositions.menuWidth - 80 : menuPositions.menuLeft;
        this.setState({
          menuTop: menuPositions.menuTop,
          menuLeft: menuLeft,
          menuWidth: menuPositions.menuWidth,
          inputHeight: menuPositions.inputHeight
        });

        if (this.props.onExpand) {
          this.props.onExpand(this.state.expanded);
        }
      }
    }
  }, {
    key: "getFilteredItems",
    value: function getFilteredItems() {
      return this.props.items;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var dropdownSettings = {
        top: this.state.menuTop,
        itemHeight: (0, _CwThemeService.getMouseMode)() ? 24 : 32,
        inputHeight: this.state.inputHeight,
        maxItemsPerPage: 10,
        numOfItems: this.props.items.length,
        numOfExtraItems: 0
      };
      var dropdownPosition = (0, _CwDropdownService.calcDropdownPosition)(dropdownSettings);
      var style = {
        // Pass calculated position coordinates to dropdown with inline style
        left: this.state.menuLeft,
        top: dropdownPosition.top,
        minWidth: this.state.menuWidth,
        height: dropdownPosition.menuHeight
      };
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId
      }, _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_button"),
        className: this.props.className,
        ref: function ref(menuButton) {
          return _this3.cwButton = menuButton;
        },
        onBlur: this.handleInputBlur,
        onFocus: this.props.onFocus,
        onKeyDown: this.handleKeyDown,
        onClick: this.handleInputClick,
        tabIndex: this.props.disabled ? -1 : this.props.tabIndex,
        honorTextCasing: this.props.honorTextCasing,
        icon: this.props.icon,
        value: this.props.value,
        rightIcon: this.props.rightIcon,
        isStandard: false,
        disabled: this.props.disabled,
        isMenu: this.props.showMenuIcon,
        menuIcon: this.props.menuIcon
      }), this.state.expanded ? _react.default.createElement(_CwDropdown.default, {
        cwId: "".concat(this.props.cwId, "_menu"),
        items: this.props.items,
        value: this.state.value,
        highlightedIndex: this.state.highlightedIndex,
        style: style,
        onClick: function onClick(item) {
          _this3.onMenuItemSelected(item);
        },
        onMouseEnter: this.highlightItemFromMouse,
        onMouseDown: this.setIgnoreBlur,
        ref: function ref(dropdown) {
          return _this3.cwDropdown = dropdown;
        }
      }) : null);
    }
  }]);
  return CwMenuButton;
}(_react.default.Component);

CwMenuButton.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Array of items to be listed in the dropdown. Must contain at least "id" and "name" fields.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    name: _propTypes.default.string
  })),

  /**
   * Index of the item selected from the list. Based on "id" field.
   */
  selectedIndex: _propTypes.default.number,

  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired when combobox's dropdown is expanded
   */
  onExpand: _propTypes.default.func,

  /**
   * Used to force combobox's dropdown to be expanded if set to true
   */
  open: _propTypes.default.bool,

  /**
   * Text for the button
   */
  value: _propTypes.default.string,

  /**
   * Used to control if we convert button's value to uppercase
   */
  honorTextCasing: _propTypes.default.bool,

  /**
   * Used to control tab index
   */
  tabIndex: _propTypes.default.number,

  /**
   * Used for the menu icon
   */
  menuIcon: _propTypes.default.string,

  /**
   * Hides the menu icon if set to false
   */
  showMenuIcon: _propTypes.default.bool,

  /**
   * Optional icon displayed to the left of the button's text if text exist
   */
  icon: _propTypes.default.string,

  /**
   * Optional icon displayed to the right of the button's text if text exist
   */
  rightIcon: _propTypes.default.string,

  /**
   *  Callback fired when an item is selected in the drop down
   */
  onDropDownItemClick: _propTypes.default.func,

  /**
   * Controls if menubutton is disabled
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: _propTypes.default.func
};
CwMenuButton.defaultProps = {
  tabIndex: 0,
  items: [],
  showMenuIcon: true
};
var _default = CwMenuButton;
exports.default = _default;